import {
  getEndCustomerPaymentBundleById as APIGetPaymentBundleById,
  getEndCustomerPaymentBundles as APIGetAllPaymentBundles,
  updateEndCustomerPaymentBundleById as APIUpdatePaymentBundle,
} from "API/swesum";
import { createContext, useContext, useEffect, useState } from "react";
import { usePopupNotificationContext } from "./NotificationPopup";

const EndCustomerPaymentBundleContext = createContext(null);

export const EndCustomerPaymentBundleContextProvider = ({ children }) => {
  const { openSuccess, openError } = usePopupNotificationContext();
  const [paymentBundles, setPaymentBundles] = useState([]);
  const [paymentBundle, setPaymentBundle] = useState(null);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const getPaymentBundles = async (body) => {
    try {
      setLoading(true);
      const data = await APIGetAllPaymentBundles(JSON.stringify(body));

      const bundleMap = new Map(
        paymentBundles.map((bundle) => [bundle.Id, bundle])
      );

      data.Rows.forEach((bundle) => bundleMap.set(bundle.Id, bundle));

      const mergedBundles = Array.from(bundleMap.values());

      setPaymentBundles(mergedBundles);
      setCount(data.Count);
      return data;
    } catch (error) {
      openError(`Något gick fel ${error.message}`, 3000);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const getPaymentBundleById = async (paymentBundleId) => {
    try {
      setLoading(true);
      const data = await APIGetPaymentBundleById(paymentBundleId);
      return data;
    } catch (error) {
      openError(`Något gick fel ${error.message}`, 3000);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const updatePaymentBundle = async (paymentBundleId, body) => {
    try {
      setLoading(true);
      const data = await APIUpdatePaymentBundle(paymentBundleId, body);
      setPaymentBundle(data);
      return data;
    } catch (error) {
      openError(`Något gick fel ${error.message}`, 3000);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return (
    <EndCustomerPaymentBundleContext.Provider
      value={{
        paymentBundle,
        paymentBundles,
        setPaymentBundles,
        getPaymentBundleById,
        getPaymentBundles,
        updatePaymentBundle,
        count,
      }}
    >
      {children}
    </EndCustomerPaymentBundleContext.Provider>
  );
};

export const useEndCustomerPaymentBundles = () =>
  useContext(EndCustomerPaymentBundleContext);
